import { API } from 'config';

function PlanService($http, $resource) {

  'ngInject';

  const PlanResource = $resource(API.PLAN, { id: '@id' }, {
    list: {
      method: 'GET',
      isArray: true,
    },
    save: {
      method: 'POST',
    },
  });

  return {
    list: (id) => PlanResource.list({ id }).$promise,
    save: (plan) => PlanResource.save(plan).$promise,
  };
}

export default PlanService;



// WEBPACK FOOTER //
// ./src/services/Plan.js